const getOtherText = (mcqData) => mcqData.get("otherText");
const getNumberOfLines = (mcqData) => mcqData.get("lines");
const getShowWordCount = (mcqData) => mcqData.get("showWordCount");

export { getOtherText, getNumberOfLines, getShowWordCount };
